import { Component, inject, input, Input, OnInit } from '@angular/core';
import { coerceOpenQuoteBoolean, FinancialProductEnum, productTypeEnum, TaxType } from '../../model/open-quote.model';
import { BaseComponent } from '@app/components/base/base.component';
import { FinancialCalculatorService } from '@app/pages/quote/open-quote/services/financial-calculator.service';
import { timer } from 'rxjs';
import { InsuranceService } from '@app/services/insurance.service';
import { vehicles } from 'assets/files/vehicles';
import { environment } from '@env/environment.local';

// Cambio para merge
@Component({
  template: '',
})
export class DealViewOpenQuoteWrapper extends BaseComponent implements OnInit {
  isManualInsurance= input(false);
  nameCompany = input('');
  @Input() set deal(value: any) {
    this._deal = value;
  }
  @Input() grace: any;
  public _deal: any;

  currency: any | undefined = '';
  financialProduct = FinancialProductEnum;

  segmentOpex = [
    {
      name: 'Freightliner - Retail Business',
      value: 'FREIGHT_LINER_RETAIL_BUSINESS',
    }, //
    {
      name: 'Freightliner - Small Fleets',
      value: 'FREIGHT_LINER_SMALL_FLEETS',
    },
    {
      name: 'Freightliner - Medium fleets',
      value: 'FREIGHT_LINER_MEDIUM_FLEETS',
    }, //
    {
      name: 'Freightliner - Large fleets',
      value: 'FREIGHT_LINER_LARGE_FLEETS',
    }, //
    {
      name: 'Freightliner - Extra large fleets',
      value: 'FREIGHT_LINER_EXTRA_LARGE_FLEETS',
    }, //
  ];

  showSection: number = 1;
  taxType = TaxType;
  isActiveBallon = environment.ACTIVE_PRODUCT_BALLON;

  public readonly financialCalculator = inject(FinancialCalculatorService);
  private readonly insuranceService = inject(InsuranceService);
  constructor() {
    super();
  }

  ngOnInit() {
    // timer(1000).subscribe(() => {
    //   console.log("La deal que llega es: ", { deal: this._deal })
    // });
  }

  /*
   * Esta validacion no esta relacionada con el broker de seguros, es decir es diferente de @link{isDealWithInsurance}
   */
  isInsurance() {
    return this._deal && this._deal.type === 'Insurance';
  }

  currencySelected() {
    const currency = this._deal.currencyType;
    return currency;
  }

  selectSection(indexSection: number) {
    this.showSection = indexSection;
  }

  get isDealWithInsurance() {
    return !!this.insurance && this.insurance.insuranceId != null;
  }

  get insurance() {
    return this._deal?.insurance;
  }
  get insurancePayments() {
    return this.insurance?.openQuoteInsurancePayments || [];
  }
  get insuranceType() {
    return this.insuranceService.insuranceList.find(typeOption => typeOption.value === this.insurance?.insuranceType);
  }

  get isAvailableInsurancePayments() {
    return this.insurancePayments.length > 0;
  }

  get model(){
    return this._deal?.openQuoteModel;
  }
  get brand(){
    return this._deal?.openQuoteBrand;
  }
  get subBrand(){
    return this._deal?.openQuoteSubBrand;
  }

  get gracePeriod(){
    return this.isManualInsurance() ? this.grace : this._deal?.grace;
  }

  get insuranceUse() {
    const productType = this._deal.productType;
    const useList = productType === productTypeEnum.autobuses ? this.insuranceService.useListBuses : this.insuranceService.useListTracts;
    return useList.find(useOption => useOption.value === this.insurance?.vehicleServiceType);
  }
  get loadType(){
    const _loadType = this.insurance.loadType;
    const productType = this._deal.productType;
    const isBus = productType === productTypeEnum.autobuses;
    return isBus ? "" : _loadType;
  }

  get subBrandImg(){
    const productType = this._deal.productType;
    const savedImg = this.subBrand?.subBrandUrl;
    if(savedImg){
      return savedImg;
    }
    // console.log("Muestrp default img para:", productType);
    switch (productType?.toUpperCase()) {
      case productTypeEnum.accesorios:
        return vehicles.accesorios;
        break;
      case productTypeEnum.vanes:
        return vehicles.sprinter;
        break;
      case productTypeEnum.autobuses:
        return vehicles.autobus;
        break;
      case productTypeEnum.camiones:
        return vehicles.camion;
        break;
      case productTypeEnum.tractos:
        return vehicles.cascadia;
        break;
      case productTypeEnum.nonDamiler:
        return vehicles.nondaimler;
        break;
      default:
        return null;
    }
  }

  getTaxFree(deal: any) {
    let taxValue = deal.taxFree || deal.taxFree == "true" ? true : false;
    if(this.nameCompany() == "DTFS" && deal.financialProductType == FinancialProductEnum.directCredit) {
      taxValue = false;
    } else if(deal.financialProductType == FinancialProductEnum.financialLeasing || deal.financialProductType == FinancialProductEnum.pureLease) {
      taxValue = false;
    }
    return taxValue;
  }

  get isShowBalloon() {
    return (this._deal.financialProductType == FinancialProductEnum.directCreditGlobe && this.isActiveBallon) ||
           (this._deal.financialProductType == FinancialProductEnum.financialLeasing && this.isActiveBallon) ||
           this._deal.financialProductType == FinancialProductEnum.capLoan ||
           this._deal.financialProductType == FinancialProductEnum.realEstate;
  }
  get isBalloonFixedAmount() {
    return this._deal.balloonType == TaxType.fixedAmount;
  }

  readonly featureLoyaltyFeriaQuotation = environment.featureLoyaltyFeriaQuotation;

  /** Vista solo lectura: propuesta Loyalty (`dealIsLoyalty` en open quote). */
  dealLoyaltyReadonlyYesNo(): string {
    if (!this.featureLoyaltyFeriaQuotation || !this._deal) {
      return '';
    }
    return coerceOpenQuoteBoolean(this._deal.dealIsLoyalty) ||
      coerceOpenQuoteBoolean(this._deal.loyaltyFinancialPackage)
      ? 'Sí'
      : 'No';
  }
}
